import {
    Component,
    OnInit,
    ViewChild,
    ElementRef,
    Input,
    Renderer2,
} from '@angular/core';
import { IonList, ModalController } from '@ionic/angular';
import { ProductWizardService } from '../../../../shared/state/product-wizard/product-wizard.service';
import { LoadingService } from '../../../../shared/state/loading/loading.service';
import { Observable } from 'rxjs';
import { KeyboardQuery } from '../../../../shared/state/keyboard/keyboard.query';
import { ProductWizardQuery } from '../../../../shared/state/product-wizard/product-wizard.query';
import { UnitsListPopperComponent } from '../../../../shared/components/wizard/units-list-popper/units-list-popper.component';
import { Browser } from '@capacitor/browser';
import { ClinicDetailQuery } from 'src/app/shared/state/clinic-detail/clinic-detail.query';

@Component({
    selector: 'app-product-view',
    templateUrl: './product-view.component.html',
    styleUrls: ['./product-view.component.scss'],
})
export class ProductViewComponent implements OnInit {
    private readonly MAX_UNITS = 100;
    private readonly MIN_UNITS = 0;
    
    currentUnits = 1;
    /** Flowwwer template */
    clinicName$: Observable<string>;
    
    @ViewChild('dataContainer') dataContainer: ElementRef;
    @Input() productId: string;
    keyboardIsShowing: Observable<boolean>;
    @ViewChild('unitsListPopper')
    unitsListPopper: UnitsListPopperComponent;



    constructor(
        private modalController: ModalController,
        private productWizardService: ProductWizardService,
        private productWizardQuery: ProductWizardQuery,
        private loadingService: LoadingService,
        private keyboardQuery: KeyboardQuery,
        private renderer: Renderer2,
        private clinicDetailQuery: ClinicDetailQuery
    ) {}

    async ngOnInit(): Promise<void> {
        this.keyboardIsShowing = this.keyboardQuery.select('isShowing');
        this.loadingService.updateShowSpinner(true);
        let productHtmlPage = await this.productWizardService.getProductHtmlPage(
            this.productId
        );
        const unitsProduct = this.productWizardQuery.getUnitsByProductId(
            this.productId
        );
        this.currentUnits = unitsProduct > 0 ? unitsProduct : 1;
        this.loadingService.updateShowSpinner(false);

        //TODO Hacerlo por back
        var urlRegex = /(http|https):\/\/([\w_-]+(?:(?:\.[\w_-]+)+))([\w.,@?;^=%&:\/~+#-]*[\w@?^=%&\/~+#-])/g;
        productHtmlPage = productHtmlPage.replace(urlRegex, function (
            url: string
        ) {
            if (!url.includes('custom_app')) {
                return (
                    '<a href="' +
                    url +
                    '" target="_blank" class="product_link">' +
                    url +
                    '</a>'
                );
            } else {
                return url;
            }
        });

        this.dataContainer.nativeElement.innerHTML = productHtmlPage;

        const linkElements = document.querySelectorAll('.product_link');
        linkElements.forEach((link: HTMLElement) => {
            this.renderer.listen(link, 'click', (event) => {
                event.preventDefault();
                this.openUrl(link.getAttribute('href'));
            });
        });

        /** Flowwwer template */
        this.clinicName$ = this.clinicDetailQuery.select('commercialName');
    }

    dismissModal(confirm) {
        this.modalController.dismiss({
            dismissed: true,
            confirmed: confirm,
            currentUnits: this.currentUnits,
        });
    }

    selectUnits(units) {
        this.currentUnits = units;
        //this.popperUnitsContent.hide();
    }

    popperOnShown(event) {
        this.unitsListPopper.initUnits();
        setTimeout(() => {
            this.unitsListPopper.scrollToCurrentUnits();
        }, 100);
    }

    removeUnits() {
        if (this.currentUnits > this.MIN_UNITS) {
            this.currentUnits--;
        }
    }

    addUnits() {
        if (this.currentUnits < this.MAX_UNITS) {
            this.currentUnits++;
        }
    }
    
    openUrl(link): void {
        Browser.open({ url: link });
    }
}
